<template>
  <div class="goup">
    <div class="tips-container">
      <img
        class="image"
        src="https://btw-common-data.betterwestar.com/btw-admin/resource/70b99ab1006567559690c03760c0b99a_wh=1101_459.png"
        alt=""
      />
      <div
        class="btn"
        :class="{ 'btn-disabled': activityInfo.activity_state == 3 }"
        @click="bindJump"
        >{{ activityInfo.activity_state == 3 ? '活动已结束' : '去看看' }}</div
      >
    </div>
    <div class="my-prize-content">
      <PrizeList />
    </div>
  </div>
</template>

<script>
import PrizeList from './prize-list.vue'
export default {
  components: { PrizeList },
  data() {
    return {
      isEnd: true
    }
  },
  computed: {
    activityInfo() {
      return this.$store.state.coachActivity2024.activityInfo
    }
  },
  created() {},
  methods: {
    bindJump() {
      if (this.activityInfo.activity_state == 1) {
        this.$betterwe.jumpRoute('/ugcTopicUgcListPage?topicId=142')
      } else if (this.activityInfo.activity_state == 2) {
        this.$toast('活动未开始')
      }
    },
    bindSend() {
      this.$store.commit('coachActivity2024/setShowSendFlowerToast', true)
    },
    bindMyPrize() {
      this.$store.commit('coachActivity2024/setMyPrizeToast', true)
    },
    bindGetFlower() {
      this.$store.commit('coachActivity2024/setTaskToast', true)
    },
    bindGetRecord() {
      this.$store.commit('coachActivity2024/setRecordToast', true)
    }
  }
}
</script>
<style lang="scss" scoped>
.goup {
  padding: 420px 0px 10px;
  .tips-container {
    margin: 0 auto 4px;
    width: 367px;
    height: 153px;
    position: relative;
    box-sizing: border-box;
    .image {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
    .btn {
      position: absolute;
      left: 50%;
      bottom: 20px;
      transform: translate(-50%, 0%);
      width: 298px;
      height: 44px;
      background: linear-gradient(
        287deg,
        #fc3c87 0%,
        #fe285e 58%,
        #fc5c72 100%
      );
      border-radius: 25px;
      font-weight: bold;
      font-size: 18px;
      color: #ffffff;
      line-height: 44px;
      text-align: center;
    }
    .btn-disabled {
      background: rgba(5, 11, 39, 0.1);
      color: rgba(5, 11, 39, 0.5);
      font-weight: normal;
      font-size: 16px;
    }
  }
  .my-prize-content {
    padding: 0px 10px;
  }
}
</style>
